import {notice} from "/assets/js/utils/notices";
import {nsFetch} from "/assets/js/utils/fetch";

class ProductCard {
    addCartBtns;
    сounterBtns;
    headerCart;
    container;

    constructor (container = document) {
        this.container = container;
        this.headerCart = document.querySelector('.header__actions-cart');
        this.init();
    }

    init() {
        // Используем делегирование событий для работы с динамически добавленными элементами
        this.container.addEventListener('click', this._changeCart);
        // Обработчик изменения значения в input
        this.container.addEventListener('change', this._handleQtyInputChange);
        this.container.addEventListener('blur', this._handleQtyInputBlur);
    }

    // Метод для переинициализации (на случай если нужно обновить обработчики)
    reinit() {
        // Делегирование событий уже работает, но можно обновить headerCart если нужно
        this.headerCart = document.querySelector('.header__actions-cart');
    }

    _changeCart = async (e) => {
        // Проверяем, что клик был по нужным элементам
        const addBtn = e.target.closest('.add-to-cart');
        const counterBtn = e.target.closest('.qty-counter__btn--product');
        
        // Если клик не по нужным элементам, выходим
        if (!addBtn && !counterBtn) {
            return;
        }
        
        e.preventDefault();

        let counter = null;
        let productCount = null;

        if (addBtn) {
            // Находим каунтер для прелоадера
            counter = addBtn.nextElementSibling?.closest('[data-counter]') || addBtn.nextElementSibling?.querySelector('[data-counter]');
            
            const data = {
                'productId': addBtn.dataset.id,
            };

            // Добавляем прелоадер
            if (counter) {
                counter.classList.add('is-loading');
            }

            try {
                productCount = await this._addToCart(data);

                if (productCount) {
                    const counterValue = addBtn.nextElementSibling.querySelector('.qty-counter__value');
                    if (counterValue) {
                        if (counterValue.tagName === 'INPUT') {
                            counterValue.value = productCount;
                            counterValue.dataset.value = productCount;
                        } else {
                            counterValue.textContent = productCount;
                        }
                    }
                    // Показываем counter и скрываем кнопку
                    this._showCounter(addBtn);
                } else {
                    // Если произошла ошибка (productCount === null), проверяем состояние
                    // Если каунтер уже виден, но товара нет в корзине, возвращаем кнопку
                    if (counter && !counter.classList.contains('is-hidden')) {
                        // Проверяем текущее значение в каунтере
                        const counterValue = counter.querySelector('.qty-counter__value');
                        const currentValue = counterValue ? (counterValue.tagName === 'INPUT' ? parseInt(counterValue.value, 10) : parseInt(counterValue.textContent, 10)) : 0;
                        
                        // Если значение 0 или каунтер был показан ошибочно, возвращаем кнопку
                        if (currentValue === 0 || currentValue === 1) {
                            this._showAddButton(counter);
                        }
                    }
                }
            } finally {
                // Убираем прелоадер
                if (counter) {
                    counter.classList.remove('is-loading');
                }
            }
        } else if (counterBtn) {
            // Находим каунтер для прелоадера
            counter = counterBtn.closest('[data-counter]');
            const parent = counterBtn.closest('.qty-counter__wrap') || counterBtn.parentNode;

            const data = {
                'productId': counterBtn.dataset.id,
            };

            // Добавляем прелоадер
            if (counter) {
                counter.classList.add('is-loading');
            }

            try {
                if (counterBtn.classList.contains('qty-counter__btn--plus')) {
                    productCount = await this._addToCart(data);
                } else {
                    productCount = await this._removeFromCart(data);
                }

                if (productCount !== null) {
                    const counterValue = parent.querySelector('.qty-counter__value') || counter?.querySelector('.qty-counter__value');
                    if (counterValue) {
                        if (counterValue.tagName === 'INPUT') {
                            counterValue.value = productCount;
                            counterValue.dataset.value = productCount;
                        } else {
                            counterValue.textContent = productCount;
                        }
                    }
                    
                    // Если количество стало 0, возвращаем кнопку "Добавить в корзину"
                    if (productCount === 0) {
                        this._showAddButton(counter);
                    }
                } else {
                    // Если произошла ошибка при добавлении (товара нет в наличии)
                    // Проверяем, нужно ли вернуть кнопку
                    if (counterBtn.classList.contains('qty-counter__btn--plus')) {
                        // При ошибке добавления проверяем текущее значение
                        // Если товара нет в корзине (значение 0 или 1), возвращаем кнопку
                        const counterValue = parent.querySelector('.qty-counter__value') || counter?.querySelector('.qty-counter__value');
                        if (counterValue) {
                            const currentValue = counterValue.tagName === 'INPUT' ? parseInt(counterValue.value, 10) || 0 : parseInt(counterValue.textContent, 10) || 0;
                            
                            // Если значение 0 или 1 (товар не был добавлен), возвращаем кнопку
                            if (currentValue <= 1) {
                                this._showAddButton(counter);
                            }
                        } else {
                            // Если нет элемента значения, возвращаем кнопку
                            this._showAddButton(counter);
                        }
                    }
                }
            } finally {
                // Убираем прелоадер
                if (counter) {
                    counter.classList.remove('is-loading');
                }
            }
        }
    }

    _addToCart = async (data) => {
        const response = await nsFetch.doFetch({
            action: 'ns_add_to_cart',
            body: data
        });

        if (!response.success) {
            notice(
                response.data.message,
                'error'
            );
            return null;
        } else {
            notice(
                response.data.message,
                'success'
            );

            this.checkCartCoutNineNinePlus(response.data.total_count);

            return response.data.product_count;
        }
    }

    _removeFromCart = async (data) => {
        const response = await nsFetch.doFetch({
            action: 'ns_remove_from_cart',
            body: data
        });

        if (!response.success) {
            notice(
                response.data.message,
                'error'
            );
            return null;
        } else {
            notice(
                response.data.message,
                'success'
            );

            this.checkCartCoutNineNinePlus(response.data.total_count);
            
            return response.data.product_count;
        }
    }

    _showCounter(addBtn) {
        if (!addBtn) return;
        
        // Скрываем кнопку "Добавить в корзину"
        addBtn.classList.add('is-hidden');
        
        // Показываем counter
        const counter = addBtn.nextElementSibling?.closest('[data-counter]') || addBtn.nextElementSibling?.querySelector('[data-counter]');
        if (counter) {
            counter.classList.remove('is-hidden');
        }
    }

    checkCartCoutNineNinePlus(cartCount) {
        if (cartCount > 99) {
            this.headerCart.dataset.cartCount = '99+';
            this.headerCart.classList.add('nine-nine-plus');
        } else {
            this.headerCart.dataset.cartCount = cartCount;
            this.headerCart.classList.remove('nine-nine-plus');
        }
    }

    _showAddButton(counter) {
        if (!counter) return;
        
        // Скрываем counter
        counter.classList.add('is-hidden');
        
        // Находим и показываем кнопку "Добавить в корзину"
        // Ищем в контейнере кнопок или в родительском элементе
        const buttonsContainer = counter.closest('.product-card__buttons') || 
                                 counter.closest('.single-product__prices') ||
                                 counter.parentElement;
        if (buttonsContainer) {
            const addBtn = buttonsContainer.querySelector('.add-to-cart');
            if (addBtn) {
                addBtn.classList.remove('is-hidden');
            }
        }
    }

    _handleQtyInputChange = async (e) => {
        const qtyInput = e.target.closest('[data-qty-input]');
        if (!qtyInput) return;

        e.preventDefault();
        
        const newValue = parseInt(qtyInput.value, 10) || 0;
        const productId = qtyInput.dataset.id;
        const counter = qtyInput.closest('[data-counter]');
        
        if (!productId || newValue < 0) {
            // Восстанавливаем предыдущее значение
            const oldValue = parseInt(qtyInput.dataset.value, 10) || 0;
            qtyInput.value = oldValue;
            return;
        }

        // Получаем текущее значение из корзины (из data-value или из значения input)
        const currentValue = parseInt(qtyInput.dataset.value, 10) || 0;

        if (newValue === currentValue) {
            return; // Значение не изменилось
        }

        // Добавляем прелоадер
        if (counter) {
            counter.classList.add('is-loading');
        }

        try {
            // Используем новый endpoint для установки точного количества
            const response = await nsFetch.doFetch({
                action: 'ns_set_cart_quantity',
                body: {
                    productId: productId,
                    quantity: newValue
                }
            });

            if (!response.success) {
                notice(response.data.message, 'error');
                // Восстанавливаем предыдущее значение при ошибке
                qtyInput.value = currentValue;
                return;
            }

            notice(response.data.message, 'success');

            // Обновляем значение в input и data-value
            const productCount = response.data.product_count;
            qtyInput.value = productCount;
            qtyInput.dataset.value = productCount;

            this.checkCartCoutNineNinePlus(response.data.total_count);

            // Если количество стало 0, возвращаем кнопку "Добавить в корзину"
            if (productCount === 0) {
                this._showAddButton(counter);
            }
        } finally {
            // Убираем прелоадер
            if (counter) {
                counter.classList.remove('is-loading');
            }
        }
    }

    _handleQtyInputBlur = (e) => {
        const qtyInput = e.target.closest('[data-qty-input]');
        if (!qtyInput) return;

        // При потере фокуса обновляем data-value текущим значением
        const currentValue = parseInt(qtyInput.value, 10) || 0;
        qtyInput.dataset.value = currentValue;
    }
}

// Создаем глобальный экземпляр ProductCard для доступа из других модулей
let cartInstance = null;

document.addEventListener('DOMContentLoaded', () => {
    cartInstance = new ProductCard();
    // Делаем доступным глобально для переинициализации
    window.cartInstance = cartInstance;
});